import { render, staticRenderFns } from "./JdsSelectField.vue?vue&type=template&id=2dfd0b6b&scoped=true&"
import script from "./JdsSelectField.vue?vue&type=script&lang=ts&"
export * from "./JdsSelectField.vue?vue&type=script&lang=ts&"
import style0 from "./JdsSelectField.vue?vue&type=style&index=0&id=2dfd0b6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd0b6b",
  null
  
)

export default component.exports